import { type ReactNode, useState } from 'react';
import { DebugFooter } from '../components/DebugFooter';
import { EnvironmentBanner } from '../components/EnvironmentBanner';
import { Header } from '../components/Header';
import { Sidebar } from '../components/Sidebar';

export function AdminLayout({ children }: { children: ReactNode }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-background text-text">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <EnvironmentBanner />
        <Header />
        <main className="flex-1 min-w-0 p-6 overflow-auto">{children}</main>
        <DebugFooter />
      </div>
    </div>
  );
}
